import { TypedForm, ObjectSchema, object, array } from 'libs/form';
import { localFileScheme } from 'modules/client/common/helpers';

import { LocalFileEntity } from '../types';

export interface CompanyConstituentDocsFilesFormType {
  constituentDocsFiles: LocalFileEntity[];
}

export const getCompanyConstituentDocsFilesSchema =
  (): ObjectSchema<CompanyConstituentDocsFilesFormType> =>
    object({
      constituentDocsFiles: array().of(localFileScheme).required().min(1),
    });

export const { Field, Form, useFormContext, Submit } =
  TypedForm<CompanyConstituentDocsFilesFormType>();
